
export const msgGetRelatoriosErro = 'Ocorreu um erro ao listar os relatórios: ';

export const msgRelatorioSolicitadoSucesso = 'Relatório solicitado com sucesso.';

export const msgRelatorioSolicitadoErro = 'Erro ao solicitar relatório. ';

export const msgRelatorioSolicitadoJaExiste = 'Um relatório com as mesmas informações já foi solicitado. ';

export const msgRelatorioValidacaoSucesso = 'Relatório validado com sucesso.';

export const msgRelatorioValidacaoErro = 'Não existe um relatório válido para os dados preenchidos.';

export const msgRelatorioValidacaoLimiteExcedido = 'Limite de validações excedido. Tente novamente mais tarde.'

export const msgRelatorioDownloadErro = 'Erro ao baixar relatório.';
